export default __webpack_public_path__ + "static/a3-43b5fbc6ec031fa421b3991abbe5154c.jpg";